import { TargetPayload } from "shared/models";
import { TargetSelectorArea } from "components/audience-map/components/TargetSelectorsArea/TargetSelectorsArea";
import { useTargetSelector } from "components/audience-map/components/hooks";
import { SuggestionStart } from "static/media";
import { SuggestedRoute } from "module/eddm/dto";
import cn from "classnames";

interface AudienceAttributesProps {
  suggestionsEnabled: boolean | null;
  selectedTargets: TargetPayload[];
  updateSelectedTargets: (targets: TargetPayload[]) => void;
  onSubmit: () => void;
  setShouldAutoSave: (shouldAutoSave: boolean) => void;
  suggestedRoutes: SuggestedRoute[];
}

export const AudienceAttributes = ({
  suggestionsEnabled,
  selectedTargets,
  updateSelectedTargets,
  onSubmit,
  setShouldAutoSave,
  suggestedRoutes,
}: AudienceAttributesProps) => {
  const { limitedSelectorsOptions, nonSelectedOptions } = useTargetSelector({
    selectedTargets,
    updateSelectedTargets,
    suggestionsEnabled,
    fullTargets: false,
    setShouldAutoSave,
    metadata: { origin: "map_demographics_attributes" },
  });

  return (
    <div
      className={cn("cb-v2-root w-full px-[17px] py-3", {
        "border-b-0": suggestedRoutes.length > 0,
      })}
    >
      <div>
        <p className="mb-[5px] text-sm font-normal text-[#2e3860] dark:text-foreground">Audience attributes</p>
        <TargetSelectorArea
          selectorsOptions={limitedSelectorsOptions}
          multiple
          nonSelectedOptions={nonSelectedOptions}
        />
      </div>
      {!suggestionsEnabled && !!selectedTargets.length && (
        <button
          data-cy="audienceAttributesApplyButton"
          className="relative mt-[15px] flex w-full cursor-pointer items-center justify-center rounded border border-border p-2.5 font-bold text-foreground"
          onClick={onSubmit}
        >
          Suggest routes
          <SuggestionStart stroke="#ee4360" style={{ marginLeft: "5px" }} />
        </button>
      )}
    </div>
  );
};
